import 'bootstrap/dist/js/bootstrap.js'

import { createApp } from 'vue'
import router from '@/router.js'
import store from '@/store.js'
import App from '@/App.vue'
import Icon from "@/components/Icon.vue"

const app = createApp(App)
app.use(router)
app.use(store)
app.mount('#app')
app.component('icon', Icon)
